import axios from "axios";
import qs from "query-string";

import { checkTokenValidity, refreshToken } from '../helper/auth';

const axiosClient = axios.create({
  baseURL: window.REACT_APP_BE_URL,

  headers: {
    "content-type": "application/json",
  },
  paramsSerializer: {
    // encode: (params) => qs.stringify(params, { arrayFormat: 'repeat' })
  },
});

axiosClient.interceptors.request.use(async (config) => {
  //hanlde tooken...
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.authorization = `Bearer ${token}`;
  }

  return config;
});

axiosClient.interceptors.response.use(
  (response) => {

    return response;
  },
  async (error) => {

    const originalRequest = error.config;

    // if (error.response.status === 401 && !originalRequest._retry) {
    //   originalRequest._retry = true;
    //   alert(401)
    //   await refreshToken();
    //   const newToken = localStorage.getItem("token");
    //   // Thực hiện lại yêu cầu gốc với token mới
    //   originalRequest.headers.Authorization = `Bearer ${newToken}`;
    //   return axiosClient(originalRequest);
    // }
    var validToken = checkTokenValidity(localStorage.getItem('token'));
    if (!validToken) {
      const refreshDone = await refreshToken();
      if (refreshDone == true) {
        const newToken = localStorage.getItem("token");
        // Thực hiện lại yêu cầu gốc với token mới
        originalRequest.headers.Authorization = `Bearer ${newToken}`;
        return axiosClient(originalRequest);
      }

    }
    return Promise.reject(error);
  }
);


export default axiosClient;
